import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Product, ProductTemp } from '@app/core/interfaces';
import { ApiResult } from '@app/core/services';
import { environment } from '@env/environment';
import { ButtonModule } from 'primeng/button';
import { PrimeNG } from 'primeng/config';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { FileBeforeUploadEvent, FileRemoveEvent, FileSelectEvent, FileUpload, FileUploadEvent, FileUploadModule } from 'primeng/fileupload';
import { MessageModule } from 'primeng/message';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-product-ocr-form',
  imports: [CommonModule, ButtonModule, FormsModule, MessageModule, FileUploadModule],
  templateUrl: './product-ocr-form.html'
})
export class ProductOcrForm {
  @ViewChild('fileUpload') fileUpload!: FileUpload;

  private destroy$: Subject<any> = new Subject();
  
  protected readonly apiUrl: string = environment.apiUrl;

  isSendingDatas: boolean = false;

  file: File | null = null;

  uploadedFile: File | any | null = null;
  productTemp: ProductTemp | null = null;

  fileError: string = '';

  constructor(
    private dialogRef: DynamicDialogRef,
    private config: PrimeNG, 
  ) { }

  onFileSelect(event: FileSelectEvent) {
    if (event.files && event.files.length > 0) {
      if (this.fileUpload.maxFileSize && event.files[0].size > this.fileUpload.maxFileSize) {
        this.fileError = `La limite de ${this.formatSize(this.fileUpload.maxFileSize)} est dépassée par le fichier <code>${event.files[0].name}</code>, avec une taille de ${this.formatSize(event.files[0].size)}.`;
      } else {
        this.file = event.files[0];
      }
    }
  }

  onFileClear(event: Event) {
    this.file = null;
  }

  onFileRemove(event: FileRemoveEvent) {
    this.file = null;
  }

  onFileUpload(event: FileUploadEvent) {
    if (event.files && event.files.length > 0) {
      this.uploadedFile = event.files[0];
    }

    if (event.originalEvent instanceof HttpResponse) {
      const result = event.originalEvent.body as ApiResult<ProductTemp>;
      this.productTemp = result.result;
      this.hideDialog();
    }
  }

  formatSize(bytes: any) {
    const k = 1024;
    const dm = 3;
    const sizes = this.config.translation.fileSizeTypes as string[];
    if (bytes === 0) {
        return `0 ${sizes[0]}`;
    }

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

    return `${formattedSize} ${sizes[i]}`;
  }

  hideDialog(): void {
    this.isSendingDatas = false;
    this.dialogRef.close(this.productTemp || null);
  }

  onSubmit(): void {
    this.isSendingDatas = true;
    if (this.file) this.uploadPhoto()
    else this.hideDialog();
  }

  uploadPhoto() {
    if (this.fileUpload && this.fileUpload.hasFiles()) {
      this.fileUpload.url = `${this.apiUrl}/produits_temporaires/`;
      this.fileUpload.uploader();
    }
  }

  ngOnDestroy(): void {
    if (this.destroy$) {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
  }
}
